<template>
    <v-dialog :value="isOpen" @click:outside="closeDialog()" max-width="500">
        <ValidationObserver ref="obs">
            <v-card>
                <v-progress-linear
                    v-if="isLoading"
                    indeterminate
                    color="primary"
                    rounded
                    height="6"
                ></v-progress-linear>

                <v-card-title class="pa-0 shadow-1">
                    <v-img
                        :src="
                            require('@/assets/illustrations/bg_modal_card.svg')
                        "
                        cover
                        position="left bottom"
                        class="align-center"
                        height="65px"
                    >
                        <v-card-title class="font-weight-medium primary--text">
                            Eliminar Mensaje
                        </v-card-title>
                    </v-img>
                </v-card-title>

                <v-card-text style="max-height: 350px">
                    <v-form>
                        <v-row dense>
                            <v-col cols="12">
                                <v-card-text class="font-weight-medium">
                                    Esta seguro que desea eliminar este mensaje?
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="mx-2">
                    <v-spacer></v-spacer>
                    <v-hover v-slot:default="{ hover }">
                        <v-btn
                            text
                            rounded
                            class="mr-1"
                            :color="hover ? 'error' : 'grey'"
                            @click="closeDialog()"
                        >
                            Cancelar
                        </v-btn>
                    </v-hover>

                    <v-hover v-slot:default="{ hover }">
                        <v-btn
                            rounded
                            :loading="isLoading"
                            :disabled="isLoading"
                            color="error"
                            :class="hover ? 'shadow-2' : 'shadow-4'"
                            class="px-8"
                            @click="deleteAction()"
                        >
                            Eliminar
                        </v-btn>
                    </v-hover>
                </v-card-actions>
            </v-card>
        </ValidationObserver>
    </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
export default {
    props: {
        isOpen: {
            type: Boolean
        },
        item: {
            type: Object
        }
    },
    data() {
        return {
            isLoading: false
        };
    },
    methods: {
        async deleteAction() {
            this.isLoading = true;
            try {
                await PbxHttpClient.delete(`/admin/message/${this.item.id}`);
                this.closeDialog(true);
                this.$snotify.success("Mensaje eliminado con exito", "¡Hecho!");
            } catch (err) {
                this.$snotify.error(
                    "Hubo un error eliminando el mensaje",
                    "Error"
                );
            }
            this.isLoading = false;
        },
        closeDialog(itRefresh = false) {
            this.$emit("dialog:close", itRefresh);
        }
    }
};
</script>

<style></style>
